/**
 * Runtime configuration.
 *
 * The bundle carries no configuration: `public/boot.json` is written by build.mjs and fetched
 * here at startup, so the same bundle can be deployed against any environment.
 */
let loading = null;
let loaded = null;

/** Loads the configuration once; concurrent callers await the same request. */
export async function loadConfig() {
  if (loaded) {
    return loaded;
  }
  loading ??= fetch('/boot.json', { cache: 'no-cache' })
    .then((response) => {
      if (!response.ok) {
        throw new Error(`Failed to load /boot.json: ${response.status} ${response.statusText}`);
      }
      return response.json();
    })
    .then((config) => {
      loaded = config;
      return config;
    })
    .finally(() => {
      // a failed load can be retried
      loading = null;
    });
  return loading;
}

/** The configuration; throws if {@link loadConfig} has not resolved yet. */
export function getConfig() {
  if (!loaded) {
    throw new Error('Configuration not loaded yet: call loadConfig() first');
  }
  return loaded;
}
